
class HXFormFieldBoolDropdown extends HXFormField {

    constructor(inputName,formName) {
        super(inputName,formName);
    }

    /**
     * Liefert den Text der gewaehlten Option
     * @returns {*}
     */
    getSelectedText() {
        return this.inputObj.options[this.inputObj.selectedIndex].text;
    }

    /**
     * Liefert den Value der gewaehlten Option - identisch zu .getValue()
     * @returns {string}
     */
    getSelectedValue() {
        return this.getValue();
    }


    /**
     * Liefert zurueck ob der Leereintrag "-" angezeigt wird
     * @returns {string}
     */
    getOptionEmptyDisplay() {
        return this.inputObj.getAttribute("data-hx-optionempty") === 'true';
    }

    /**
     * Liefert Text des Leereintrages, wenn dieser angezeigt wird
     * @returns {string}
     */
    getOptionEmptyText() {
        var text = null;
        if (this.getOptionEmptyDisplay()===true) {
            for (var i = 0; i < this.inputObj.length; ++i) {
                if (this.inputObj.options[i].value === "-1") text = this.inputObj.options[i].text;
            }
        }
        return text;
    }

    /**
     * Leereintrag "-" ein oder ausblenden
     * @param show
     * @param text
     */
    setOptionEmpty(show,text="-") {
        var nullOptionIndex = null;
        for (var i = 0; i < this.inputObj.length; ++i){
            if (this.inputObj.options[i].value === "-1") nullOptionIndex = i;
        }

        if (nullOptionIndex===0 && show===false) {
            this.inputObj.remove(nullOptionIndex);
        } else if(nullOptionIndex===null && show===true) {
            this.inputObj.add(new Option(text,"-1"),0);
        } else if (nullOptionIndex===0 && text!==null) {
            this.inputObj.options[nullOptionIndex].text = text;
        }
        this.inputObj.setAttribute("data-hx-optionempty",show);
    }

    /**
     * @param optional
     */
    setOptional(optional) {
        super.setOptional(optional,'select');
    }

    /**
     * @returns {boolean}
     */
    validateInput(alertResult=true) {
        super._validateFieldInit();

        if (this.fieldExists()===true && this.getEditable() === true) {
            if (!this.getOptional() && this.getOptionEmptyDisplay() && this.inputObj.options.selectedIndex<=0) { //<=0 weil: wird mit setValue() auf einen nicht vorhandenen Wert gesetzt, so steht der Index auf -1
                this.validationMsg = hx.replace(this.formVars.dictOptionalMsg, "#name#", this.getLabel());
                this.validationPassed = false;
            }
            if (alertResult===true) super._validateFieldAlert();
        }
        return this.validationPassed;
    }

    displayInit() {

    }

}